import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, createUnknownComponentVNode as _$cc, map as _$ma } from 'intact-vue';
import { getRestProps, mapChildren } from '../utils';
import { CarouselItem } from './item';
import { Button } from '../button';
import { Icon } from '../icon';
import { makeStyles } from './styles';
import { linkEvent } from 'intact-vue';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    arrow = _this$get.arrow,
    effect = _this$get.effect;
  var _this$slide = this.slide,
    translate = _this$slide.translate,
    shouldTransition = _this$slide.shouldTransition,
    elementRef = _this$slide.elementRef,
    isSlide = _this$slide.isSlide;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-carousel"] = true, _classNameObj[className] = className, _classNameObj[k + "-" + arrow] = true, _classNameObj[k + "-stop"] = !shouldTransition.value, _classNameObj[k + "-" + effect] = true, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var _this$items = this.items,
    getItems = _this$items.getItems,
    getItemsWithCloned = _this$items.getItemsWithCloned;
  var _this$autoplay = this.autoplay,
    stop = _this$autoplay.stop,
    play = _this$autoplay.play;
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this), {
    'ref': elementRef,
    'ev-mouseenter': stop,
    'ev-mouseleave': play
  }), [_$ce(2, 'div', getItemsWithCloned(), 0, _$cn(k + "-carousel-wrapper"), {
    'style': {
      transform: isSlide() ? "translate3d(" + translate.value + "px, 0, 0)" : undefined
    }
  }), _$cc(Button, {
    'icon': true,
    'circle': true,
    'type': 'none',
    'size': 'large',
    'className': _$cn(k + "-carousel-btn " + k + "-prev"),
    'ev-click': this.prev,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-left")
    })
  }), _$cc(Button, {
    'icon': true,
    'circle': true,
    'type': 'none',
    'size': 'large',
    'className': _$cn(k + "-carousel-btn " + k + "-next"),
    'ev-click': this.next,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-right")
    })
  }), _$ce(2, 'div', _$ma(getItems(), function ($value, $key) {
    var _$cn2;
    return _$ce(2, 'div', null, 1, _$cn((_$cn2 = {}, _$cn2[k + "-carousel-dot"] = true, _$cn2[k + "-active"] = this.isActive($value.props.value), _$cn2)), {
      'ev-click': linkEvent($key, this.setIndex)
    });
  }, $this), 4, _$cn(k + "-carousel-indicator c-clearfix"))]);
}
;